// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_InitializationPlaceholder.scss
// module id = 372
// module chunks = 86 87